module.exports = __webpack_public_path__ + "static/prueba-91543fc756b4a0da5eb49b885d0832ff.png";